$(document).ready(function () {
  resizeHalfImage();
  $(window).resize(function () {
    resizeHalfImage()
  });
});

function resizeHalfImage() {
  if ($(window).width() <= 1200) {
    $('.halfImage-wrapper').each(
      function () {
        var height = $(this).find('.content-halfImage').outerHeight();
        $(this).find('.img-holder').css('height', height);
      }
    );
  } else {
    $('.halfImage-wrapper').each(
      function () {
        $(this).find('.img-holder').css('height', '100%');
      }
    );
  }
}